<template>
    <div class="risk-scale">
        <div
            v-if="hasScore"
            class="risk-scale__active"
            :style="activeStyle"
        >
            <div class="risk-scale__marker" :style="markerStyle">
                <div class="risk-scale__marker-inner"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "RiskScale",
    props: {
        score: {
            type: [Number, String],
            default: null,
        },
    },
    computed: {
        normalizedScore() {
            if (this.score === null || this.score === undefined || this.score === "") {
                return null;
            }

            const value = Number(this.score);
            if (!isFinite(value) || value < 0) {
                return null;
            }

            return Math.min(5, value);
        },
        hasScore() {
            return this.normalizedScore !== null;
        },
        activeStyle() {
            if (!this.hasScore) {
                return {};
            }

            const level = Math.max(1, Math.floor(this.normalizedScore));
            return {
                left: `${(level - 1) * 20}%`,
            };
        },
        markerStyle() {
            if (!this.hasScore) {
                return {};
            }

            const level = Math.floor(this.normalizedScore);
            const decimal = level === 5 ? 0 : this.normalizedScore - level;

            return {
                left: `calc(${decimal * 100}% - ${decimal * 20}px)`,
            };
        },
    },
};
</script>

<style scoped>
.risk-scale {
    position: relative;
    width: 100%;
    height: 15px;
    margin-top: 2px;
    background-color: #e8e7e9;
}

.risk-scale__active {
    position: absolute;
    top: 0;
    width: 20%;
    height: 15px;
    background-color: #a1d0e3;
}

.risk-scale__marker {
    position: absolute;
    bottom: -3px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #0077cf;
}

.risk-scale__marker-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #fff;
    transform: translate(-50%, -50%);
}
</style>
